import React from 'react';
import {
    Datagrid,
    TextField,
    BooleanField,
    BooleanInput,
    DateField,
    Filter,
    List,
    SearchInput,
    EditButton,
} from 'react-admin';

const NewsTypeFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
        <BooleanInput
            source="is_enabled"
            label="resources.news_types.fields.is_enabled"
        />
    </Filter>
);

const NewsTypeList = (props: any) => (
    <List
        {...props}
        filters={<NewsTypeFilter />}
        sort={{ field: 'created_at', order: 'DESC' }}
        perPage={10}
        exporter={false}
        bulkActionButtons={false}
    >
        <Datagrid optimized rowClick="edit">
            <TextField source="name" label="resources.news_types.fields.name" />
            <BooleanField
                source="is_enabled"
                label="resources.news_types.fields.is_enabled"
            />
            <DateField
                source="created_at"
                type="date"
                label="resources.news_types.fields.created_at"
            />
            <EditButton />
        </Datagrid>
    </List>
);

export default NewsTypeList;
